// Regulile R.E.S.D.P.S. copiate din API (spec E, 5.3), fara Vue si fara importuri, ca sa poata fi testate cu node.
// API-ul ramane cel care decide; aici servesc la afisare si la evitarea cererilor sortite esecului.

export const RESDPS_FIRST_YEAR = 2026;
export const IN_PROGRESS_FILTER = "in-lucru";
export const ALL_FILTER = "toate";
export const IN_PROGRESS_STATUSES = Object.freeze([
  "Draft",
  "Registered",
  "ToTransmit",
]);

export const STATUS_LABELS = Object.freeze({
  Draft: "Ciorna",
  Registered: "Inregistrat",
  ToTransmit: "Sesizare de transmis",
  Transmitted: "Transmis",
  Classified: "Clasat",
  Cancelled: "Anulat",
});

export const STATUS_TAGS = Object.freeze({
  Draft: "is-light",
  Registered: "is-info",
  ToTransmit: "is-warning",
  Transmitted: "is-success",
  Classified: "is-dark",
  Cancelled: "is-danger",
});

export const ORIGIN_LABELS = Object.freeze({
  CdpsRequest: "Cerere C.D.P.S.",
  ExOfficio: "Din oficiu",
});

export const AUDIT_ACTION_LABELS = Object.freeze({
  Created: "Creat",
  Modified: "Modificat",
  Deleted: "Sters",
  Registered: "Inregistrat",
  Rectified: "Rectificat",
  VerdictRecorded: "Verdict bunuri/debite",
  Classified: "Clasat",
  ChamberRegistered: "Inregistrat la Camera",
  Cancelled: "Anulat",
  ViewedFile: "Consultare dosar",
  ViewedRegister: "Consultare registru",
  DocumentGenerated: "Document generat",
});

// Etichetele butoanelor de actiune, cu cheile din matricea API; ordinea e cea a butoanelor pe dosar.
export const ACTION_LABELS = Object.freeze({
  EditDraft: "Editeaza",
  Register: "Inregistreaza",
  DeleteDraft: "Sterge ciorna",
  RecordAssetsVerdict: "Verdict bunuri/debite",
  Classify: "Clasare",
  RecordChamberRegistration: "Inregistrare la Camera",
  GenerateSdps: "Genereaza S.D.P.S.",
  Rectify: "Rectificare",
  Cancel: "Anulare",
});

// Numele JSON ale campurilor (SuccessionFileFields din API), cu eticheta afisata in liste, rectificari si istoric.
export const FIELD_LABELS = Object.freeze({
  origin: "Tip sesizare",
  cdpsReceivedDate: "Data primirii cererii",
  deceasedLastName: "Nume",
  deceasedFatherInitial: "Initiala tatalui",
  deceasedFirstName: "Prenume",
  cnp: "CNP",
  cnpMissingReason: "Motivul lipsei CNP",
  domicileLocality: "Localitate domiciliu",
  domicileCounty: "Judet domiciliu",
  domicileStreet: "Strada",
  domicileNumber: "Nr.",
  domicileBlock: "Bl.",
  domicileStaircase: "Sc.",
  domicileFloor: "Et.",
  domicileApartment: "Ap.",
  domicileCua: "Cod unic de adresa",
  dateOfDeath: "Data decesului",
  deathCertificateNumber: "Numarul actului de deces",
  deathPlaceLocality: "Localitatea decesului",
  deathPlaceCounty: "Judetul decesului",
  fiscalRollNumber: "Nr. de rol nominal unic",
  agriculturalRegisterVolume: "Registrul agricol - volum",
  agriculturalRegisterPosition: "Registrul agricol - pozitie",
  observations: "Observatii",
  registryEntryId: "Legatura cu registratura generala",
  notaryChamberId: "Camera notarilor",
  chamberRegistrationNumber: "Numar Camera",
  chamberRegistrationDate: "Data Camera",
  hasAssetsOrDebts: "Bunuri sau debite",
  reason: "Motiv",
  status: "Stare",
  cancellationReason: "Motivul anularii",
  generalRegistryNumber: "Nr. registratura generala",
  generalRegistryDate: "Data registratura generala",
  year: "An",
  number: "Numar",
  registrationDate: "Data inregistrarii",
});

// Textul pus de API la Observatii la clasare (ResdpsDeadlines); pastreaza diacriticele din Ordinul 407/2026.
export const CLASSIFICATION_MENTION =
  "fără bunuri imobile/mobile, precum și fără debite la bugetul local";

export const LIST_STATUS_OPTIONS = Object.freeze(
  [{ value: IN_PROGRESS_FILTER, label: "In lucru" }]
    .concat(
      Object.keys(STATUS_LABELS).map((status) => ({
        value: status,
        label: STATUS_LABELS[status],
      }))
    )
    .concat([{ value: ALL_FILTER, label: "Toate" }])
);

// Campurile text din SuccessionFileData (fara origine, date si legatura cu registratura).
export const TEXT_FIELDS = Object.freeze([
  "deceasedLastName",
  "deceasedFatherInitial",
  "deceasedFirstName",
  "cnp",
  "cnpMissingReason",
  "domicileLocality",
  "domicileCounty",
  "domicileStreet",
  "domicileNumber",
  "domicileBlock",
  "domicileStaircase",
  "domicileFloor",
  "domicileApartment",
  "domicileCua",
  "deathCertificateNumber",
  "deathPlaceLocality",
  "deathPlaceCounty",
  "fiscalRollNumber",
  "agriculturalRegisterVolume",
  "agriculturalRegisterPosition",
  "observations",
]);

// ---- reguli ----

// Matricea din SuccessionFileTransitions (API); ordinea cheilor da ordinea butoanelor.
const ALLOWED = Object.freeze({
  EditDraft: ["Draft"],
  DeleteDraft: ["Draft"],
  Register: ["Draft"],
  Rectify: ["Registered", "ToTransmit", "Transmitted", "Classified"],
  RecordAssetsVerdict: ["Registered", "ToTransmit"],
  Classify: ["Registered"],
  RecordChamberRegistration: ["ToTransmit"],
  Cancel: ["Registered", "ToTransmit"],
  GenerateSdps: ["ToTransmit"],
});

export const allowedActions = (status) =>
  Object.keys(ALLOWED).filter(
    (action) => ALLOWED[action].indexOf(status) !== -1
  );

const isMissing = (value) =>
  value === null || value === undefined || value === "";
const isBlank = (value) => isMissing(value) || String(value).trim() === "";

// SuccessionFileRegistrationRules.MissingForDraft
export const missingForDraft = (data) => {
  const missing = [];
  if (isMissing(data.origin)) missing.push("origin");
  if (isBlank(data.deceasedLastName)) missing.push("deceasedLastName");
  if (isBlank(data.deceasedFirstName)) missing.push("deceasedFirstName");
  if (isMissing(data.dateOfDeath)) missing.push("dateOfDeath");
  return missing;
};

// SuccessionFileRegistrationRules.MissingForRegistration, in aceeasi ordine
export const missingForRegistration = (data) => {
  const missing = [];
  if (isBlank(data.deceasedLastName)) missing.push("deceasedLastName");
  if (isBlank(data.deceasedFirstName)) missing.push("deceasedFirstName");
  if (isBlank(data.cnp) && isBlank(data.cnpMissingReason)) missing.push("cnp");
  if (data.origin === "CdpsRequest" && isMissing(data.cdpsReceivedDate))
    missing.push("cdpsReceivedDate");
  [
    "domicileLocality",
    "domicileCounty",
    "deathCertificateNumber",
    "deathPlaceLocality",
    "deathPlaceCounty",
  ].forEach((field) => {
    if (isBlank(data[field])) missing.push(field);
  });
  if (isMissing(data.registryEntryId)) missing.push("registryEntryId");
  return missing;
};

// SuccessionFileRegistrationRules.MissingForChamberRegistration
export const missingForChamberRegistration = (data) => {
  const missing = [];
  if (isMissing(data.notaryChamberId)) missing.push("notaryChamberId");
  if (isBlank(data.chamberRegistrationNumber))
    missing.push("chamberRegistrationNumber");
  if (isMissing(data.chamberRegistrationDate))
    missing.push("chamberRegistrationDate");
  return missing;
};

// SuccessionFileRegistrationRules.EnsureValidValues: cererea de deschidere a succesiunii se depune dupa deces,
// deci nu poate fi primita inaintea lui. Acelasi mesaj il intoarce API-ul pe campul „Data primirii cererii”.
export const CDPS_BEFORE_DEATH_MESSAGE =
  "Data primirii cererii nu poate fi anterioara datei decesului.";

export const cdpsReceivedBeforeDeath = (data) => {
  const received = fromApiDate(data.cdpsReceivedDate);
  const death = fromApiDate(data.dateOfDeath);
  return !!received && !!death && received < death;
};
// ---- CNP (CnpValidator din API) ----

const CONTROL_KEY = "279146358279";

export const normalizeCnp = (value) =>
  isMissing(value) ? "" : String(value).replace(/\s+/g, "");

const exactDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
    ? date
    : null;
};

const birthDate = (sex, year, month, day, today) => {
  // 1-2: 1900, 3-4: 1800, 5-6: 2000; 7-9 (rezidenti): 2000, sau 1900 daca 2000 ar da o data in viitor.
  const century = sex <= 2 ? 1900 : sex <= 4 ? 1800 : 2000;
  const birth = exactDate(century + year, month, day);
  if (birth && sex >= 7 && birth > today) {
    return exactDate(1900 + year, month, day);
  }
  return birth;
};

export const isValidCnp = (cnp, dateOfDeath, today) => {
  if (typeof cnp !== "string" || !/^[0-9]{13}$/.test(cnp)) return false;
  const digits = cnp.split("").map(Number);
  if (digits[0] === 0) return false;

  const birth = birthDate(
    digits[0],
    digits[1] * 10 + digits[2],
    digits[3] * 10 + digits[4],
    digits[5] * 10 + digits[6],
    startOfDay(today)
  );
  if (!birth) return false;
  if (dateOfDeath && birth > startOfDay(dateOfDeath)) return false;

  const sum = digits
    .slice(0, 12)
    .reduce(
      (total, digit, index) => total + digit * Number(CONTROL_KEY[index]),
      0
    );
  const control = sum % 11 === 10 ? 1 : sum % 11;
  return control === digits[12];
};

// ---- date ----

const pad = (value, length = 2) => String(value).padStart(length, "0");

export function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

// Datele fara ora din API ("2026-09-14T00:00:00") devin miezul noptii local.
export const fromApiDate = (value) => {
  if (isMissing(value)) return null;
  if (value instanceof Date) return startOfDay(value);
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  return match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : null;
};

// Componentele locale; toISOString ar putea da ziua anterioara.
export const toApiDate = (date) =>
  date instanceof Date && !isNaN(date.getTime())
    ? date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate())
    : null;

// Campurile *AtUtc vin fara "Z"; fara el ar fi citite ca ora locala.
export const fromApiUtc = (value) => {
  if (isMissing(value)) return null;
  const text = String(value);
  return new Date(/(Z|[+-]\d{2}:\d{2})$/.test(text) ? text : text + "Z");
};

export const formatDate = (value) => {
  const date = fromApiDate(value);
  return date
    ? pad(date.getDate()) +
        "." +
        pad(date.getMonth() + 1) +
        "." +
        date.getFullYear()
    : "";
};

export const formatDateTime = (date) =>
  date instanceof Date && !isNaN(date.getTime())
    ? formatDate(date) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes())
    : "";

export const daysBetween = (from, to) =>
  Math.round((startOfDay(to) - startOfDay(from)) / 86400000);

export const deadlineState = (deadline, today) => {
  const date = fromApiDate(deadline);
  if (!date) return { state: "none", days: null };
  const days = daysBetween(today, date);
  return { state: days < 0 ? "late" : days <= 7 ? "soon" : "ok", days };
};

export const deadlineLabel = ({ state, days }) => {
  if (state === "none") return "";
  if (days < 0) return "depasit";
  if (days === 0) return "astazi";
  return days === 1 ? "1 zi" : days + " zile";
};

// Butonul „Clasare”: acelasi rezultat ca API-ul, dar ceasul serverului ramane cel care decide.
export const canClassify = (detail, today) => {
  if (detail.status !== "Registered" || detail.hasAssetsOrDebts !== false)
    return false;
  const availableFrom = fromApiDate(detail.classificationAvailableFrom);
  return !!availableFrom && startOfDay(today) >= availableFrom;
};

export const registerYears = (today) => {
  const years = [];
  for (let year = today.getFullYear(); year >= RESDPS_FIRST_YEAR; year--)
    years.push(year);
  return years;
};

// ---- formatare ----

export const statusLabel = (status) => STATUS_LABELS[status] || status;
export const statusTag = (status) => STATUS_TAGS[status] || "is-light";
export const fieldLabel = (field) => FIELD_LABELS[field] || field;
export const auditActionLabel = (action) =>
  AUDIT_ACTION_LABELS[action] || action;

// Tokenul de acces poate veni fara email; atunci se afiseaza sub-ul Auth0 (decizia proprietarului, 2026-09-15).
export const userLabel = (email, sub) =>
  isBlank(email) ? (isBlank(sub) ? "—" : sub) : email;

// Identificatori interni, fara sens pentru functionar; numarul si data din registratura apar pe randuri proprii.
const TECHNICAL_FIELDS = Object.freeze([
  "successionFileId",
  "registryEntryId",
  "notaryChamberId",
]);

export const isTechnicalField = (field) =>
  TECHNICAL_FIELDS.indexOf(field) !== -1;

export const formatRegisterNumber = (number) =>
  isMissing(number) ? "" : pad(number, 5);

export const formatDeceased = (data) =>
  [data.deceasedLastName, data.deceasedFatherInitial, data.deceasedFirstName]
    .filter((part) => !isBlank(part))
    .join(" ");

export const formatLocality = (locality, county) =>
  [
    isBlank(locality) ? null : locality,
    isBlank(county) ? null : "jud. " + county,
  ]
    .filter(Boolean)
    .join(", ");

export const formatAddress = (data) =>
  [
    ["str.", data.domicileStreet],
    ["nr.", data.domicileNumber],
    ["bl.", data.domicileBlock],
    ["sc.", data.domicileStaircase],
    ["et.", data.domicileFloor],
    ["ap.", data.domicileApartment],
  ]
    .filter((part) => !isBlank(part[1]))
    .map((part) => part[0] + " " + part[1])
    .join(", ");

export const formatAgriculturalRegister = (data) => {
  const volume = data.agriculturalRegisterVolume;
  const position = data.agriculturalRegisterPosition;
  if (isBlank(volume) && isBlank(position)) return "";
  return (
    "vol. " +
    (isBlank(volume) ? "—" : volume) +
    ", poz. " +
    (isBlank(position) ? "—" : position)
  );
};

// Valorile din rectificari si din jurnal vin ca text (datele yyyy-MM-dd, enum-urile cu numele lor).
export const formatAuditValue = (field, value) => {
  if (isMissing(value)) return "—";
  const text = String(value);
  if (field === "status") return statusLabel(text);
  if (field === "origin") return ORIGIN_LABELS[text] || text;
  if (field === "hasAssetsOrDebts")
    return text.toLowerCase() === "true" ? "Da" : "Nu";
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(text))
    return formatDate(text) + " " + text.substr(11, 5);
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return formatDate(text);
  return text;
};

// ---- lista: filtrele stau in adresa paginii (?stare=&an=&cauta=&pagina=) ----

export const statusesForFilter = (filter) => {
  if (filter === ALL_FILTER) return [];
  if (STATUS_LABELS[filter]) return [filter];
  return IN_PROGRESS_STATUSES.slice();
};

export const listStateFromQuery = (query) => {
  const values = query || {};
  const status =
    values.stare === ALL_FILTER || STATUS_LABELS[values.stare]
      ? values.stare
      : IN_PROGRESS_FILTER;
  const year = /^\d{4}$/.test(values.an || "") ? Number(values.an) : null;
  const page = Math.max(parseInt(values.pagina, 10) || 1, 1);
  return { status, year, search: values.cauta || "", page };
};

export const queryFromListState = (state) => {
  const query = {};
  if (state.status && state.status !== IN_PROGRESS_FILTER)
    query.stare = state.status;
  if (state.year) query.an = String(state.year);
  if (state.search) query.cauta = state.search;
  if (state.page > 1) query.pagina = String(state.page);
  return query;
};

// ---- formularul <-> API ----

export const emptyForm = () => {
  const form = {
    origin: "CdpsRequest",
    cdpsReceivedDate: null,
    dateOfDeath: null,
    registryEntryId: null,
    notaryChamberId: null,
    chamberRegistrationNumber: "",
    chamberRegistrationDate: null,
  };
  TEXT_FIELDS.forEach((field) => {
    form[field] = "";
  });
  return form;
};

export const formFromDetail = (detail) => {
  const form = emptyForm();
  TEXT_FIELDS.forEach((field) => {
    form[field] = isMissing(detail[field]) ? "" : detail[field];
  });
  form.origin = detail.origin;
  form.cdpsReceivedDate = fromApiDate(detail.cdpsReceivedDate);
  form.dateOfDeath = fromApiDate(detail.dateOfDeath);
  form.registryEntryId = isMissing(detail.registryEntryId)
    ? null
    : detail.registryEntryId;
  form.notaryChamberId = isMissing(detail.notaryChamberId)
    ? null
    : detail.notaryChamberId;
  form.chamberRegistrationNumber = detail.chamberRegistrationNumber || "";
  form.chamberRegistrationDate = fromApiDate(detail.chamberRegistrationDate);
  return form;
};

const cleanText = (value) => (isBlank(value) ? null : String(value).trim());

// Tot formularul: API-ul inlocuieste toate campurile, deci un camp gol trimis ca null sterge valoarea.
export const toFilePayload = (form, options) => {
  const includeChamber = !!(options && options.includeChamber);
  const payload = {
    origin: isMissing(form.origin) ? null : form.origin,
    cdpsReceivedDate: toApiDate(form.cdpsReceivedDate),
    dateOfDeath: toApiDate(form.dateOfDeath),
    registryEntryId: isMissing(form.registryEntryId)
      ? null
      : form.registryEntryId,
  };
  TEXT_FIELDS.forEach((field) => {
    payload[field] = cleanText(form[field]);
  });
  if (payload.cnp !== null) payload.cnp = normalizeCnp(payload.cnp);
  if (includeChamber) {
    payload.notaryChamberId = isMissing(form.notaryChamberId)
      ? null
      : form.notaryChamberId;
    payload.chamberRegistrationNumber = cleanText(
      form.chamberRegistrationNumber
    );
    payload.chamberRegistrationDate = toApiDate(form.chamberRegistrationDate);
  }
  return payload;
};
